import classNames from "classnames";
import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

import { TabButton } from "./buttons/tabButton";

const TabsButtons = ({ tabs }) => {
  return (
    <ScrollContainer className={"flex"} horizontal={true}>
      {tabs.map(tab => {
        return (
          <TabButton
            key={tab.text}
            {...tab}
            className={classNames(
              "shrink-0 flex-1 whitespace-nowrap",
              tab.className
            )}
          />
        );
      })}
    </ScrollContainer>
  );
};

export default TabsButtons;
